export default function ProcessSection() {
  const steps = [
    {
      number: "01",
      title: "Étude Gratuite",
      description: "Analyse de votre serre, calcul des besoins en déshumidification et vérification de l'éligibilité au financement CEE.",
      icon: "ri-file-search-line"
    },
    {
      number: "02",
      title: "Dimensionnement",
      description: "Sélection des équipements adaptés à votre surface, type de culture et objectifs d'hygrométrie.",
      icon: "ri-ruler-line"
    },
    {
      number: "03",
      title: "Montage Dossier CEE",
      description: "Constitution et dépôt du dossier de financement CEE AGRI-TH-117. Nous gérons toutes les démarches administratives.",
      icon: "ri-folder-line"
    },
    {
      number: "04",
      title: "Installation",
      description: "Installation professionnelle par nos techniciens certifiés RGE. Mise en service et formation à l'utilisation.",
      icon: "ri-tools-line"
    },
    {
      number: "05",
      title: "Mise en Service",
      description: "Paramétrage des systèmes, tests de fonctionnement et optimisation des réglages selon vos cultures.",
      icon: "ri-settings-3-line"
    },
    {
      number: "06",
      title: "Suivi & Maintenance",
      description: "Accompagnement continu, maintenance préventive et assistance technique pour garantir la performance.",
      icon: "ri-customer-service-line"
    }
  ];

  return (
    <section id="processus" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Notre Processus d'Installation</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Un accompagnement complet de A à Z pour votre projet de déshumidification
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="relative bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border-2 border-gray-200 hover:border-[#4F8B3A] transition-all duration-300 hover:shadow-lg"
            >
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-[#4F8B3A] rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                {step.number}
              </div>
              <div className="w-14 h-14 bg-[#0066A1]/10 rounded-lg flex items-center justify-center mb-4 mt-2">
                <i className={`${step.icon} text-2xl text-[#0066A1]`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        {/* Timeline Connector for Desktop */}
        <div className="hidden lg:block relative mt-12">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#4F8B3A] via-[#0066A1] to-[#4F8B3A] opacity-20"></div>
        </div>
      </div>
    </section>
  );
}
